export default class Balloon extends Phaser.GameObjects.Container {
  /**
   *  A simple prefab (extended game object class), displaying a spinning
   *  Phaser 3 logo.
   *
   *  @extends Phaser.GameObjects.Container
   */
  constructor(scene, x, y, color, autoStart) {
    super(scene, 0, 0, []);
    // console.log('new balloon! --> ' + color);
    this.offset = 0.35;
    this.active = autoStart;
    this.animating = false;
    this.balloon = scene.add.image(0, 0, 'sprites', 'balloon.png');
    this.bWidth = this.balloon.width;
    this.shade = scene.add.image(0, 0, 'sprites', 'balloon_texture.png');
    this.highlight = scene.add.image(0, 0, 'sprites', 'balloon_highlight.png');
    this.collided = false;
    let offset = 12;
    this.holder = scene.add.container(0, offset, [this.balloon, this.shade]);
    this.color = color;
    this.balloon.tint = color;
    this.shade.tint = color;
    this.radius = this.balloon.width;
    this.clickPoint = { x: 0, y: 0 };
    this.boundsPoint = { x: 0, y: 0 };
    this.transform = scene.add.container(0, 0, [this.holder, this.highlight]);
    this.add(this.transform);
    this.emitter = new Phaser.Events.EventEmitter();
    this.activeInGame = true;
    y -= this.balloon.height / 2;

    this.velX = 0;
    this.velY = 0;
    this.angVel = 0;
    this.gravity = 1;
    this.forceX = 0;
    this.forceY = 0;
    this.bounce = 0.9;
    this.swayX = 0;
    this.prevAngle = this.angle;
    this.setPosition(x, y);
    this.lastX = x;
    this.lastY = y;

    this.circle = new Phaser.Geom.Circle(0, 0, 0);
    this.bounds = 75;
  }

  setPhysics(scene, data) {
    this.worldWidth = scene.cameras.main.width;
    this.worldHeight = scene.cameras.main.height - data.floor;
    this.gravityConst = data.gravity;
    this.impulseX = data.impulseX;
    this.impulseY = data.impulseY;
    this.dragX = data.dragX;
    this.dragY = data.dragY;
    this.angDrag = data.angDrag;
    this.bounce = data.bounce;
    this.swayAmp = data.swayAmp;
    this.swaySpeed = data.swaySpeed;
    this.collideBounce = data.collideBounce;
    this.heightBonus = data.heightBonus;
    this.swayOffset = Phaser.Math.Between(0, 3143);
    this.swayAcc = data.swayAcc;
    this.shadow = scene.add.image(this.x, this.worldHeight, 'sprites', 'balloon_shadow.png');
    this.shadow.setOrigin(0.5, 1);
    // this.shadow.setDisplaySize(this.displayWidth, this.displayHeight * 0.33);
    this.shadow.tint = '#000000';
    this.shadow.alpha = 0.6;
    this.shadowHeight = this.shadow.displayHeight;
    this.lastVelX = 0;
    this.lastVelY = 0;
    this.transform.angle = 180;
  }

  stop() {
    this.activeInGame = false;
    this.balloon.off('pointerdown');
    this.emitter.off('balloonClicked');
    //this.angVel = 0;
  }

  /**
   *  Increment the angle smoothly.
   */
  update(balloons, dt, t, gravity) {
    // this.angle += 0.1;
    if (this.active && !this.animating) {
      this.lastX = this.x;
      this.lastY = this.y;

      let targetX = this.x;
      let targetY = this.y;

      // this.gravity = this.lerp(this.gravity, this.gravityConst, dt * 0.0015)*dt;
      this.gravity = gravity * dt;

      this.swayX = this.lerp(
        this.swayX,
        Math.sin(this.swayOffset + t * this.swaySpeed) *
        this.swayAmp *
        this.clamp01(1 - Math.abs(this.forceX)),
        dt * 0.0015
      );

      this.velY += this.gravity + (this.forceY);
      this.velX += this.swayX + this.forceX;

      // onsole.log(this.velX + ', ' + this.velY);
      targetY += this.velY;
      targetX += this.velX;

      this.forceY *= this.dragY;
      this.forceX *= this.dragX;

      this.velY = 0;
      this.velX = 0;

      // let angle = 200 * (this.forceX / 40);
      // this.angle = angle;

      this.x = targetX;

      this.y = targetY;

      let width = this.radius;
      let height = this.radius;

      this.clickPoint = this.rotateAroundPoint(this.holder.x, this.holder.y, this.transform.angle);
      //this.clickPoint.x += this.x;
      //this.clickPoint.y += this.y;

      let x = this.clickPoint.x + this.x;
      let y = this.clickPoint.y + this.y;
      if (x + width / 2 > this.worldWidth) {
        this.x = this.worldWidth - (width / 2 + 1);
        this.forceX = -1 * ((this.forceX + this.swayX) * this.bounce);
        this.triggerCollision();
      } else if (x - width / 2 < 0) {
        this.x = width / 2 - 1;
        this.forceX = -1 * ((this.forceX + this.swayX) * this.bounce);
        this.triggerCollision();
      }

      if (y + height / 2 > this.worldHeight) {
        this.y = this.worldHeight - height / 2;
        //this.forceY = -1 * (this.forceY * this.bounce);
        this.active = false;
        this.angVel = 0;
        if (this.activeInGame === true) {
          this.pop();
        }

      } else if (y - height / 2 < 0) {
        this.y = (height / 2) + 1;
        this.forceY = -1 * (this.forceY * this.bounce);
        this.triggerCollision();
      }

      this.collided = false;
      let sqrDist = this.radius * this.radius;
      for (let i = 0; i < balloons.length; ++i) {
        if (balloons[i] !== this) {
          let bX = balloons[i].clickPoint.x + balloons[i].x;
          let bY = balloons[i].clickPoint.y + balloons[i].y;
          let a = x - bX;
          let b = y - bY;
          let vec = new Phaser.Math.Vector2(a, b);
          let dist = vec.lengthSq();
          vec.normalize();
          if (dist < sqrDist) {
            /*             if (
                          Math.abs(x - balloons[i].clickPoint.x) < width &&
                          Math.abs(y - balloons[i].clickPoint.y) < height
                        ) { */
            /* if (this.x < balloons[i].clickPoint.x) {
              this.forceX -= this.collideBounce;
              balloons[i].forceX += this.collideBounce;
              this.emitter.emit('collided');
            } else {
              this.forceX += this.collideBounce;
              balloons[i].forceX -= this.collideBounce;\
              this.emitter.emit('collided');
            } */
            this.triggerCollision();
            this.forceX += vec.x * this.collideBounce;
            this.forceY += Math.min(0, vec.y) * this.collideBounce;
            balloons[i].forceX += -vec.x * this.collideBounce;
            balloons[i].forceY += Math.min(0, -vec.y) * this.collideBounce;
            balloons[i].collided = true;
            this.collided = true;
            return;
          }
        }
      }
    }

    let intensity = this.smoothstep(
      this.worldHeight - 200,
      this.worldHeight - 50,
      this.y
    );
    this.shadow.x = this.transform.x + this.x;
    this.shadow.setDisplaySize(
      this.radius * intensity,
      this.shadowHeight * intensity
    );
    this.shadow.alpha = 0.6 * this.clamp01(intensity + 0.2);
    this.angVel *= this.angDrag;

    this.transform.angle += this.angVel;

    this.circle.x = this.clickPoint.x + this.x;
    this.circle.y = this.clickPoint.y + this.y;
    this.circle.radius = this.bounds;
  }

  triggerCollision() {
    if (this.activeInGame) {
      this.emitter.emit('collided');
    }
  }

  transitionOut(scene, time, direction) {
    if (this.transition !== undefined) {
      this.transition.stop();
    }
    this.forceX = 0;
    this.forceY = 0;
    this.angVel *= 2;
    this.animating = true;
    this.transform.x = 0;
    this.transform.y = 0;
    let newX = this.worldWidth * direction;
    let newY = -this.worldHeight / 2;
    let randAmt = Phaser.Math.Between(75, 100) / 100;
    let dur = time * randAmt;
    this.active = false;
    this.transition = scene.tweens.add({
      targets: this.transform,
      x: newX,
      duration: dur,
      props: {
        x: { value: newX, duration: dur, ease: 'Back.easeIn' },
        y: {
          value: newY,
          duration: dur,
          ease: 'Back.easeIn'
          // easeParams: [0.9, 0.4]
        }
      }
    });
  }

  transitionIn(scene, time, direction) {
    // console.log('moving from ' + this.transform.x + ' to ' + distX);
    if (this.transition !== undefined) {
      this.transition.stop();
    }
    let startHeight = this.worldHeight / 2;
    this.animating = true;
    this.active = false;
    this.transform.x = -this.worldWidth * direction;
    this.transform.y = -startHeight;
    if (this.y >= startHeight / 2) {
      this.y -= this.heightBonus;
    }
    let newX = 0;
    let newY = 0;
    let randAmt = Phaser.Math.Between(50, 100) / 100;
    let dur = time * randAmt;
    let d = time * (1 - randAmt);
    this.angVel = Phaser.Math.Between(-500, 500) * 0.1;
    this.transition = scene.tweens.add({
      targets: this.transform,
      x: newX,
      y: newY,
      duration: dur,
      delay: d,
      ease: 'Power2',
      onComplete: () => {
        this.active = true;
        this.animating = false;
        this.transform.setPosition(0, 0);
        // this.forceX = 0;
        // this.forceY = 0;
        this.velX = 0;
        this.velY = 0;
        this.swayX = 0;
        this.gravity = 0;
      }
    });
  }

  togglePause(togglePause) {
    if (this.transition !== undefined && this.transition.isPlaying()) {
      if (togglePause == true) {
        this.transition.pause();
      } else {
        this.transition.resume();
      }
    }
  }

  setActive(toggle) {
    this.active = toggle;
  }

  clamp01(value) {
    return this.clamp(value, 0, 1);
  }

  clamp(value, min, max) {
    return Math.min(Math.max(min, value), max);
  }

  smoothstep(x, y, t) {
    var i = this.clamp01((t - x) / (y - x));
    return i * i * (3 - 2 * i);
  }

  lerp(x, y, t) {
    return (1 - t) * x + t * y;
  }

  wrap(value, length) {
    return value % length;
  }

  handleBalloonClicked(pointer) {
    if (!this.animating && this.active === true) {
      this.active = true;
      let width = this.balloon.displayWidth;
      this.forceY += this.impulseY;
      let dist = Math.abs(pointer.x - (this.clickPoint.x + this.x));
      if (pointer.x < this.x) {
        this.forceX += this.impulseX * (dist / width / 2);
      } else {
        this.forceX -= this.impulseX * (dist / width / 2);
      }
      this.angVel = 50 * (this.forceX / 40);
      this.transform.angle = this.wrap(
        90 + (Math.atan2(this.forceY, this.forceX) * 180) / 3.141,
        360
      );
      this.emitter.emit('balloonClicked');
    }
  }

  checkTap(pointer) {
    let a = (this.clickPoint.x + this.x) - pointer.x;
    let b = (this.clickPoint.y + this.y) - pointer.y;
    let dist = Math.sqrt(a * a + b * b);
    if (dist <= this.bounds) {
      this.handleBalloonClicked(pointer);
    }
  }

  pop() {
    this.emitter.emit('gameOver', {
      x: this.x,
      y: this.worldHeight,
      tint: this.color
    });
    this.shadow.destroy();
    this.destroy();
  }

  rotateAroundPoint(x, y, angle, axisX = 0, axisY = 0) {
    let radians = angle * 0.01745;
    let s = Math.sin(radians);
    let c = Math.cos(radians);
    x -= axisX;
    y -= axisY;
    let newX = x * c - y * s;
    let newY = x * s + y * c;
    return {
      x: newX + axisX,
      y: newY + axisY
    };
  }
}
